
import Logistics from "models/logistics";
const logistics = new Logistics();
export default {
  data() {
    return {
      expressList: []
    }
  },
  created() {
  },
  methods: {
    /**
     * @desc 获取快递列表
     */
    initExpressList() {
      logistics.getExpressData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.type = value.type;
            arr.push(obj);
          });
          this.expressList = arr;
        }
      });
    },
  }
}